export default __webpack_public_path__ + "static/media/noun-future-3857049.567e8d29.svg";